import axios from 'axios';

export const getInvoicesForIafsNetworkByMonth = async (props) => {
  const { newToken, year, month, commercialId, forIafsMonth = true } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${commercialId}/variableRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        forIafsMonth,
        dateMonth: month - 1,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getContractsForIafsNetworkByMonth = async (props) => {
  const { newToken, year, month, commercialId, forIafsMonth = true } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${commercialId}/energyFeeRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        forIafsMonth,
        // dateMonth: month,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getInsurancesForIafsNetworkByMonth = async (props) => {
  const { newToken, year, month, commercialId, forIafsMonth = true } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${commercialId}/insuranceRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        forIafsMonth,
        insuranceStartMonth: month - 1,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getInvoicesForIafsNetworkForAll = async (props) => {
  const { newToken, year, commercialId, forIafsMonth = true } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${commercialId}/variableRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        forIafsMonth,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getContractsForIafsNetworkForAll = async (props) => {
  const { newToken, year, commercialId, forIafsMonth = true } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${commercialId}/energyFeeRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        forIafsMonth,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getInsurancesForIafsNetworkForAll = async (props) => {
  const { newToken, year, commercialId, forIafsMonth = true } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${commercialId}/insuranceRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        forIafsMonth,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};
